import axios from "axios";
import { User } from "oidc-client-ts";
import config, { oidcConfig } from "../config";

export const SESSION_EXPIRED_EVENT = "refund:session-expired";

const getAuthUser = () => {
  const oidcStorage = localStorage.getItem(
    `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`
  );
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
};

export const api = axios.create({
  baseURL: config.apiUrl,
  xsrfHeaderName: "X-CSRF-Token",
  headers: {
    common: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  },
});

// Interceptor para adicionar o token em cada requisição
api.interceptors.request.use((config) => {
  const user = getAuthUser();
  if (user?.id_token) {
    config.headers.Authorization = `Bearer ${user.id_token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    const method = error.config?.method?.toUpperCase();
    const isWriteRequest = ["POST", "PUT", "PATCH", "DELETE"].includes(method ?? "");

    if (error.response?.status === 401 && isWriteRequest) {
      window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
    }

    return Promise.reject(error);
  },
);
